// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"592":"bf6ca574","912":"cb5bae1e"}[chunkId] + ".chunk.js";
};